<template>
    <div :id="this.$route.name">
        <card back>
            <template v-slot:header>
                <h4 class="d-inline">ثبت فیش حقوقی</h4>
                <hr />
            </template>
            <template v-slot:content>
                <div class="row" v-if="render">
                    <div class="col-md-4 col-12">
                        <small id="LblGetWorkShopCombo"> کارگاه </small>
                        <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetWorkShopCombo"
                            :defaultvalue="DataAxios.TblWorkshopId" :rownumintable="3" :disabled="editStatus"
                            :action="'TblSalaryCombo/GetWorkShopCombo'" :method="'POST'" :idinput="'GetWorkShopCombo'"
                            :keyItem="'GetWorkShopCombo'" :ClassProps="'required'"> </SearchableCombo>
                    </div>
                    <div class="col-md-4 col-12">
                        <small id="LblYear"> سال </small>
                        <input type="number" dir="ltr" @keypress="$ValidNumber($event, 4)"
                            class="form-control InputText required" v-model="DataAxios.Year" />
                    </div>
                    <div class="col-md-4 col-12">
                        <small id="LblMonthGrp26"> ماه </small>
                        <SearchableCombo :edit="false" :grp="26" :code="null" @ResultCombo="GetMonthGrp26"
                            :rownumintable="3" :defaultvalue="DataAxios.MonthGrp26" :action="'TblSalaryCombo/GetComboById'"
                            :method="'POST'" :idinput="'MonthGrp26'" :keyItem="'MonthGrp26'" :ClassProps="'required'">
                        </SearchableCombo>

                    </div>
                </div>

            </template>
        </card>
        <form v-if="Isloade & render" autocomplete="off">
            <div>
                <table id="salaryTable" class="table align-middle table-bordered border-bottom">
                    <thead class="align-middle ">
                        <!-- sticky-top -->
                        <tr>
                            <th rowspan="2" colspan="1" width="25" class="text-center"
                                style="border: 1px solid var(--table-border-color); min-width: 25px;"><span class="">
                                    #
                                </span></th>
                            <th rowspan="2" colspan="1" width="60" class="text-center"
                                style="border: 1px solid var(--table-border-color); min-width: 60px; "><span
                                    class="vertical-mode">
                                    پرسنل
                                </span></th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    کارکرد روزانه
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    غیبت
                                </span>
                            </th>
                            <th colspan="2" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    کارکرد اضافه کاری
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    کارکرد ماموریت روزانه
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    روز حق غذا
                                </span>
                            </th>
                            <th colspan="3" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    مرخصی استحقاقی
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    مرخصی استعلاجی
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    مرخصی بی حقوق
                                </span>
                            </th>
                            <th colspan="2" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    کسری کار
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    پاداش
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    عیدی
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    سنوات پایان سال
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    مساعده
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    تسهیلات
                                </span>
                            </th>
                            <th colspan="1" class="text-center" style="border: 1px solid var(--table-border-color);">
                                <span class="vertical-mode">
                                    سایر کسورات
                                </span>
                            </th>
                            <th rowspan="2" colspan="1" width="50" class="text-center"
                                style="border: 1px solid var(--table-border-color); min-width: 50px;"><span
                                    class="vertical-mode">عملیات

                                </span></th>
                        </tr>
                        <tr>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border: 1px solid var(--table-border-color);">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border: 1px solid var(--table-border-color);">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 1px solid var(--table-border-color); border-bottom: 1px solid var(--table-border-color); border-left: 0px !important; border-image: initial;">
                                ساعت
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 0px !important; border-bottom: 1px solid var(--table-border-color); border-left: 1px solid var(--table-border-color); border-image: initial;">
                                دقیقه
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border: 1px solid var(--table-border-color);">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border: 1px solid var(--table-border-color);">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 1px solid var(--table-border-color); border-bottom: 1px solid var(--table-border-color); border-left: 0px !important; border-image: initial;">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 0px !important; border-bottom: 1px solid var(--table-border-color); border-left: 0px !important; border-image: initial;">
                                ساعت
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 0px !important; border-bottom: 1px solid var(--table-border-color); border-left: 1px solid var(--table-border-color); border-image: initial;">
                                دقیقه
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border: 1px solid var(--table-border-color);">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border: 1px solid var(--table-border-color);">
                                روز
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 1px solid var(--table-border-color); border-bottom: 1px solid var(--table-border-color); border-left: 0px !important; border-image: initial;">
                                ساعت
                            </th>
                            <th width="35" class="text-center"
                                style="min-width: 35px; border-top: 1px solid var(--table-border-color); border-right: 0px !important; border-bottom: 1px solid var(--table-border-color); border-left: 1px solid var(--table-border-color); border-image: initial;">
                                دقیقه
                            </th>
                            <th width="80" class="text-center"
                                style="min-width: 80px; border: 1px solid var(--table-border-color);">
                                ریال
                            </th>
                            <th width="80" class="text-center"
                                style="min-width: 80px; border: 1px solid var(--table-border-color);">
                                ریال
                            </th>
                            <th width="80" class="text-center"
                                style="min-width: 80px; border: 1px solid var(--table-border-color);">
                                ریال
                            </th>
                            <th width="80" class="text-center"
                                style="min-width: 80px; border: 1px solid var(--table-border-color);">
                                ریال
                            </th>
                            <th width="80" class="text-center"
                                style="min-width: 80px; border: 1px solid var(--table-border-color);">
                                ریال
                            </th>
                            <th width="80" class="text-center"
                                style="min-width: 80px; border: 1px solid var(--table-border-color);">
                                ریال
                            </th>
                        </tr>
                    </thead>
                    <tbody class="align-middle border-top-0">
                        <tr v-for="(item, index) in listener" :key="index" :id="index">

                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item.NamFam }}</td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].WorkPerformanceDaily">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].AbsentPerformanceDaily">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 3)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].AddWorkPerformanceHour">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].AddWorkPerformanceMinutes">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].MissionPerformanceDaily">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].FoodPerformanceDaily">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 3)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].VacationPerformanceDay">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].VacationPerformanceHour">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].VacationPerformanceMinutes">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].SickPerformanceDay">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].NoSalaryVacationPerformance">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].MissPerformanceHourse">
                            </td>
                            <td>
                                <input type="number" @keypress="$ValidNumber($event, 2)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].MissPerformanceMinutes">
                            </td>
                            <td>
                                <input @keypress="$ValidNumber($event, 15)"
                                    @keyup="SalaryDetails[index].Rewards = $PutCommatoInput_New($event)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].Rewards">
                            </td>
                            <td>
                                <input @keypress="$ValidNumber($event, 15)"
                                    @keyup="SalaryDetails[index].Eidi = $PutCommatoInput_New($event)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].Eidi">
                            </td>
                            <td>
                                <input @keypress="$ValidNumber($event, 15)"
                                    @keyup="SalaryDetails[index].YearSanavat = $PutCommatoInput_New($event)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].YearSanavat">
                            </td>
                            <td>
                                <input @keypress="$ValidNumber($event, 15)"
                                    @keyup="SalaryDetails[index].Sos = $PutCommatoInput_New($event)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].Sos">
                            </td>
                            <td>
                                <input @keypress="$ValidNumber($event, 15)"
                                    @keyup="SalaryDetails[index].Facility = $PutCommatoInput_New($event)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].Facility">
                            </td>
                            <td>
                                <input @keypress="$ValidNumber($event, 15)"
                                    @keyup="SalaryDetails[index].MissOther = $PutCommatoInput_New($event)"
                                    class="w-100 form-control salary-input InputText salary-input"
                                    v-model="SalaryDetails[index].MissOther">
                            </td>
                            <td>
                            
                                <div class="d-flex flex-row-reverse justify-content-between">
                                <a v-if="!editStatus"  href="javascript:;" @click="deleteItem(index)" title="حذف آیتم" class="mr-2 badge" >
                                    <h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6>
                                </a>

                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </form>
        <div v-if="Isloade" class="row mt-5">
            <hr />
            <div class="col-md-4 col-12"></div>
            <div class="col-md-4 col-12"></div>
            <div class="col-md-4 col-12">
                <button v-if="editStatus == false" class="btn btn-success w-100" @click.prevent="SaveDeta()">ثبت
                    اطلاعات</button>
                <button v-else class="btn btn-success w-100" @click.prevent="EditDeta()">ویرایش اطلاعات</button>
            </div>

        </div>


    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
    data() {
        return {
            DataAxios: {},
            Isloade: false,
            ListPersonel: [],
            DataAxiosPost: {
                ArryfildValue: {},
                Method: 'post',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
            SalaryDetails: [],
            render: true,
            editStatus: false

        };
    },
    components: { Card, SearchableCombo },
    methods: {
        deleteItem(item){
            var rowToRemove = document.getElementById(item);
            rowToRemove.parentNode.removeChild(rowToRemove);
            if (this.SalaryDetails.length > 1) {
            this.SalaryDetails.splice(item, 1);
            }
        },
        GetWorkShopCombo(data) {
            if (data.id != null) {
                this.DataAxios.TblWorkshopId = data.id
                this.GetPersonel(this.DataAxios.TblWorkshopId)
            }
        },
        GetPersonel(workShopId) {
            var DataAxois = {
                ArryfildValue: {}, Method: 'Get', Action: 'Workshop/GetPersonnel/' + workShopId, Token: this.$session.get('Token'),
            };
            if (this.editStatus == false) {
                this.$PostData(DataAxois).then((data) => {
                    if (data.IsSuccess == true && data.Data != null) {
                        this.listener = data.Data
                        
                        for (let index = 0; index < this.listener.length; index++) {
                            this.SalaryDetails.push({
                                TblPersonnelId: this.listener[index].Id, WorkPerformanceDaily: this.$store.state.JalaliDate.substring(5, 7) <= '06' ? 31 : 30,
                                AbsentPerformanceDaily: 0, AddWorkPerformanceHour: 0, AddWorkPerformanceMinutes: 0,
                                MissionPerformanceDaily: 0, FoodPerformanceDaily: 0, VacationPerformanceDay: 0, VacationPerformanceHour: 0,
                                VacationPerformanceMinutes: 0, SickPerformanceDay: 0, NoSalaryVacationPerformance: 0, MissPerformanceHourse: 0,
                                MissPerformanceMinutes: 0, Rewards: 0, Eidi: 0, YearSanavat: 0, Sos: 0, Facility: 0, MissOther: 0
                            })

                        }
                        // console.log(this.SalaryDetails);
                        this.Isloade = true
                    } else {
                        this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                        this.Isloade = false
                    }
                })
            }

        },
        GetMonthGrp26(data) {
            if (data.id != null) {
                this.DataAxios.MonthGrp26 = data.id
                for (let index = 0; index < this.SalaryDetails.length; index++) {
                    if(this.editStatus == false){
                        if (data.id<=102) {
                            this.SalaryDetails[index].WorkPerformanceDaily=31 
                        }
                     else{
                            this.SalaryDetails[index].WorkPerformanceDaily=30
                        }
                    }
                 
                }
            }
        },
        SaveDeta() {
            if (this.$ValidForm(this.$route.name)) {
                this.DataAxiosPost.Action = 'Salary'
                this.DataAxiosPost.ArryfildValue.Year = this.DataAxios.Year
                this.DataAxiosPost.ArryfildValue.MonthGrp26 = this.DataAxios.MonthGrp26
                this.DataAxiosPost.ArryfildValue.TblWorkshopId = this.DataAxios.TblWorkshopId
                this.DataAxiosPost.ArryfildValue.SalaryDetails = this.SalaryDetails
                this.$PostData(this.DataAxiosPost).then((data) => {
                    if (data.IsSuccess == true) {
                        this.$toasted.success('لیست حقوق با موفقیت ایجاد شد', {
                            action: {
                                text: 'بستن',
                                onClick: (e, toastObject) => {
                                    toastObject.goAway(0)
                                },
                            },
                        })
                        this.Isloade = false
                    }
                    else {
                        if (data.IsSuccess == false) {
                            this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                        }
                    }
                })
            }
        },

        EditDeta() {
            if (this.$ValidForm(this.$route.name)) {

                let axios = {
                    Action: 'Salary',
                    Method: 'put',
                    ArryfildValue: {
                        Id : this.DataAxios.Id,
                        Year: this.DataAxios.Year,
                        MonthGrp26: this.DataAxios.MonthGrp26,
                        TblWorkshopId: this.DataAxios.TblWorkshopId,
                        SalaryDetails: this.SalaryDetails
                    },

                }
                this.$PostData(axios).then((data) => {
                    if (data.IsSuccess == true) {
                        this.$toasted.success('لیست حقوق با موفقیت ویرایش شد', {
                            action: {
                                text: 'بستن',
                                onClick: (e, toastObject) => {
                                    toastObject.goAway(0)
                                },
                            },
                        })
                        this.Isloade = false
                    }
                    else {
                        if (data.IsSuccess == false) {
                            this.$mySweetDefaultTost('', data.Message, 'info', 3000)
                        }
                    }
                }).catch(err=>{
                    this.$mySweetDefaultTost('', 'خطایی رخ داد', 'error', 3000)
                })
            }


        },


    },
    beforeMount() {
        this.DataAxios.Year = this.$store.state.JalaliDate.substring(0, 4)
    },


    mounted() {
        if (this.$route.params.Status != undefined) {
            if (this.$route.params.Status == 'Edit') {
                this.editStatus = true
                let axsios = {
                    Action: 'Salary/GetSalaryDetails/' + this.$route.params.DataRow.Id,
                    Method: 'get'
                }
                this.$PostData(axsios).then((data) => {
                    if (data.IsSuccess == true) {
                        this.listener = data.Data.SalaryDetails
                        this.DataAxios.TblWorkshopId = data.Data.TblWorkshopId
                        this.DataAxios.Year = data.Data.Year
                        this.DataAxios.MonthGrp26 = data.Data.MonthGrp26
                        this.DataAxios.Id = data.Data.Id
                        this.Isloade = true
                        for (let index = 0; index < this.listener.length; index++) {
                            this.SalaryDetails.push(data.Data.SalaryDetails[index])

                        }
                        this.render = false
                        this.$nextTick(() => {
                            this.render = true
                        })

                    } else {
                        this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                        this.Isloade = false
                    }
                })
            }
        }
    }
}
</script>
<style scoped>
table {
    background: var(--table-background);
    color: var(--sidebar-color-item);
}

.table th,
.table td {
    padding: 0.2rem;
}

.salary-input {
    text-align: center !important;
    padding: 4px 2px !important;
}
</style>